<!--div class="error" *ngIf="message ; else noerror">
    {{message}}
</div>
<ng-template #noerror>
    <router-outlet></router-outlet>
</ng-template>-->
<router-outlet></router-outlet>
